module.exports = {
    init: () => {
        const viewFacilitiesButton = $('.info-group.hours a');
        const facilitiesStrip = $('.info-group.hours section');

        const toggleMobileInfo = $('.toggle-mobile-info-groups');
        const mobileInfoGroups = $('.mobile-info-groups');

        if(viewFacilitiesButton&&facilitiesStrip){
            viewFacilitiesButton.on('click',e=>{
                facilitiesStrip.toggleClass('open');
            })
        }
        
        if(toggleMobileInfo&&mobileInfoGroups){
            toggleMobileInfo.on('click',e=>{
                mobileInfoGroups.toggleClass('open');
            })
        }
    }
}